export default __webpack_public_path__ + "static/media/warning--pavement-ends--g4.2a4100fb.png";